import React from "react";
import { MultiSingleHorizontalBar, WIDTH_WATCHING_CLASS_NAME } from "./MultiSingleHorizontalBar";
// import TextTransition, { presets } from "react-text-transition";
import { HEIGHT_WATCHING_CLASS_NAME } from "./MultiSingleHorizontalBar";
import styles from "./MultiSingleHorizontalThreeColumnBar.module.scss";

export interface MultiSingleHorizontalThreeColumnBarProps {
    id: string;
    values: number[];
    labels: string[];
    highlights: string[];
    afterHighlights: string[];
    backgroundColors: string[];
    seriesName?: string;
    maxValue?: number;
    className?: string;
    enableLabelWidthWatching?: boolean;
    queryHeightWatchingElements?: () => { watching: HTMLElement[]; update: HTMLElement[] };
    queryLabelWidthWatchingElements?: () => {
        watching: HTMLElement[];
        update: HTMLElement[];
    };
}

export const MultiSingleHorizontalThreeColumnBar: React.FC<MultiSingleHorizontalThreeColumnBarProps> = ({
    id,
    values,
    labels,
    highlights,
    afterHighlights,
    backgroundColors,
    maxValue,
    seriesName,
    className,
    enableLabelWidthWatching,
    queryHeightWatchingElements
}) => {
    const first = labels.map((d, index) => (
        <div key={index} className={`${styles.label} ${HEIGHT_WATCHING_CLASS_NAME}`}>
            {d}
        </div>
    ));
    const max = maxValue ?? Math.max(...values);
    const newData = values.map(d => (parseFloat(`${d ?? 0}`) * 100) / max);
    // console.log(afterHighlights);
    const second = newData.map((d, index) => {
        return (
            <div
                className={`${styles.midLabel} ${HEIGHT_WATCHING_CLASS_NAME} ${WIDTH_WATCHING_CLASS_NAME}`}
                key={index}
            >
                <strong
                    className={`${styles.highlight}`}
                    style={{
                        color: backgroundColors?.[index]
                    }}
                >
                    {highlights[index] ?? ""}
                </strong>{" "}
                {`${afterHighlights[index] == null ? "" : `${afterHighlights[index]}`}`}
            </div>
        );
    });

    return (
        <MultiSingleHorizontalBar
            id={id}
            className={`${className ?? ""} ${styles.multiSingleHorizontalThreeColumnBar}`}
            data={{
                data: newData,
                label: seriesName ?? "",
                backgroundColors: backgroundColors,
                borderColor: "black"
            }}
            firstColumnLabels={first}
            secondColumnLabels={second}
            enableLabelWidthWatching={enableLabelWidthWatching}
            queryHeightWatchingElements={queryHeightWatchingElements}
            getTooltipJSX={index => {
                const label = labels[index];
                const highlight = highlights[index];
                const afterHighlight = afterHighlights[index];

                return (
                    <div>
                        {label}
                        <br />
                        {highlight}
                        {afterHighlight != null && (
                            <>
                                <br /> {afterHighlight}
                            </>
                        )}
                    </div>
                );
            }}
        />
    );
};

export const MultiSingleHorizontalThreeColumnBarDemo: React.FC<{}> = () => {
    const labels = [
        "Transport",
        "Housing and community support",
        "Education, employment and training",
        "Business and environment",
        "Recreation and wellbeing",
        "Others"
    ];
    const data = [826, 548, 641, 416, 270, 129];
    const after = [292323123, 19, 23, 15, 10, 5];
    return (
        <MultiSingleHorizontalThreeColumnBar
            id="demo"
            labels={labels}
            values={data}
            backgroundColors={["green", "blue", "yellow", "red", "green", "blue"]}
            highlights={data.map(d => `$${d}M`)}
            afterHighlights={after.map(d => `(${d}%)`)}
            seriesName="demo"
        />
    );
};
